module.exports = __webpack_public_path__ + "img/costGreen.1ff0c130.png";